import styled from "styled-components";

const INK = "#2D2943";
const MUTED = "#787395";
const BORDER = "#E8E7EE";

export const FallbackCard = styled.section`
  background: #ffffff;
  border: 1px solid ${BORDER};
  border-radius: 6px;
  overflow: hidden;
  margin-bottom: 18px;
`;

export const FallbackState = styled.div`
  padding: 34px 24px 38px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const FallbackTitle = styled.h3`
  margin: 0 0 6px;
  font: 500 14px "Work Sans", sans-serif;
  color: ${INK};
`;

export const FallbackBody = styled.p`
  margin: 0 auto 14px;
  max-width: 46ch;
  font: 300 12.5px "Work Sans", sans-serif;
  line-height: 1.6;
  color: ${MUTED};
`;
